import { useImageLoaded } from '@deltasierra/react-hooks';
import * as React from 'react';
import { Loading } from '../Generic/Loaders/Loading';

export interface ImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'alt'> {
    alt?: string;
    pictureStyleProps?: React.CSSProperties;
    shouldUseLoadingFallback?: boolean;
}

export function Image({ children, pictureStyleProps, shouldUseLoadingFallback, ...props }: ImageProps): JSX.Element {
    const [isLoading, onRefChange] = useImageLoaded(props.src);

    return (
        <>
            {isLoading && shouldUseLoadingFallback && <Loading />}
            {!children && (
                <img
                    {...props}
                    ref={onRefChange}
                    style={{ display: isLoading ? 'none' : undefined, ...props.style }}
                    title={props.title}
                />
            )}
            {children && (
                <picture style={pictureStyleProps}>
                    {children}
                    <img
                        {...props}
                        ref={onRefChange}
                        style={{ display: isLoading ? 'none' : undefined, ...props.style }}
                        title={props.title}
                    />
                </picture>
            )}
        </>
    );
}

Image.displayName = 'Image';
